module.exports = "<div [innerHtml] = 'tnc'></div>"